import { type MouseEventData } from '../external-types';
import Frame from '../objects/Frame';
import { type SmartZoneConfig } from '../objects/SmartZoneBehaviors';
import ShapeDrawingBrush, {
  type CreateObjectOptions,
} from './ShapeDrawingBrush';

export interface StylusFrameOptions {
  layoutEnabled?: boolean;
  width?: number;
  height?: number;
  uniformScaling?: boolean;
  smartZoneConfig?: SmartZoneConfig;
}

// Brush for drawing frame objects.
class FrameDrawingBrush<
  O extends StylusFrameOptions
> extends ShapeDrawingBrush<O> {
  private frame: Frame;

  onMouseUp(eventData: MouseEventData) {
    if (!this.canvas._isMainEvent(eventData.e)) {
      return true;
    }

    // After the initial drawing is done, aspect ratio frames are freely resizable
    if (this.frame) {
      this.frame.uniformScaling = false;
    }

    return super.onMouseUp(eventData);
  }

  _createObject(options: CreateObjectOptions, drawing: boolean) {
    const controller = this.canvas.controller;

    const frame = new Frame({
      controller,
      ...controller.defaultsManager.for('frame'),
      ...this.initialOptions,
      ...options,

      ...(drawing
        ? {
            scaleX: 0.05,
            scaleY: 0.05,
          }
        : {}),

      textContent: `Frame ${this.countFrames() + 1}`,
      width: this.initialOptions.width ?? Frame.defaultWidth(),
      height: this.initialOptions.height ?? Frame.defaultHeight(),
    });
    this.frame = frame;
    if (this.initialOptions.smartZoneConfig) {
      controller.actionOpenSidePanel('smartZone');
    }
    return controller.addToCanvas(frame);
  }

  private countFrames() {
    return this.canvas.getObjects().filter(obj => obj.type === 'frame').length;
  }
}

export default FrameDrawingBrush;
